import styled from 'styled-components';
import { newColors } from '~/themes/variables';
import { mediaq } from '~/themes/style-utils-v2';
export const Wrapper = styled.div `
  background: #ebeaeb;
  width: 100%;
  ${mediaq.sm `background: #ffffff;`}
`;
export const TwoColumnRow = styled.div `
  display: flex;
  flex-direction: row;
  background: ${newColors.snow};
  padding: 24px;
  ${mediaq.sm `
    padding: 16px;
    flex-direction: column;
  `}
`;
export const Column = styled.div `
  flex: 1;
  &:not(:first-child) {
    border-left: 1px solid ${newColors.gray100};
    ${mediaq.sm `
      border-left: 0px;
      border-top: 1px solid ${newColors.gray100};
    `}
  }
`;
export const GraySection = styled.div `
  background: linear-gradient(180deg, #fff 76.65%, #eee 100%);
  padding: 64px 24px 96px 24px;
  position: relative;
  width: 100%;
  ${mediaq.sm `
  padding: 0;`}
`;
export const OffsetContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 36px;
  position: relative;
  padding: 0 24px;
  top: ${(props) => (props.applyOffset ? '-50px' : 'initial')};
  padding-top ${(props) => (props.applyOffset ? '0px' : '50px')};
  padding-bottom: ${(props) => (props.applyOffset ? '0px' : '50px')};
  ${mediaq.sm `
    top: ${(props) => (props.applyOffset ? '-150px' : 'initial')};
    padding-bottom: ${(props) => (props.applyOffset ? '0px' : '20px')};
  `}
  ${mediaq.md `{
    top: ${(props) => (props.applyOffset ? '-78.5px' : 'initial')};
    margin-bottom: ${(props) => (props.applyOffset ? '-50.5px' : '0')};
    gap: 28px;
  }`}
`;
export const CommercialLinkWrapper = styled.div `
  width: 100%;
  align-items: center;
`;
